import { UserCog, Package, Server, Building2, HardDrive, GitBranch, Network, KeyRound, Gauge } from 'lucide-react';
import type { SidebarTab } from '@shared/ui/layout';
import type { TFunction } from 'i18next';

const adminTabDefs = [
  { id: 'operator', labelKey: 'operator', icon: UserCog, href: '/admin/operator' },
  { id: 'service', labelKey: 'itService', icon: Package, href: '/admin/service' },
  { id: 'workflow-settings', labelKey: 'workflowSettings', icon: GitBranch, href: '/workflow-settings' },
  { id: 'portal-service', labelKey: 'portalService', icon: Server, href: '/admin/portal-service' },
  { id: 'tenants', labelKey: 'tenants', icon: Building2, href: '/admin/tenants' },
  { id: 'data-storage', labelKey: 'dataStorage', icon: HardDrive, href: '/admin/data-storage' },
  {
    id: 'mcp-platform-overview',
    labelKey: 'mcpOverview',
    icon: Network,
    href: '/admin/mcp',
    categoryKey: 'mcpPlatform',
  },
  {
    id: 'mcp-tenant-features',
    labelKey: 'mcpTenantFeatures',
    icon: Building2,
    href: '/admin/mcp/tenants',
    categoryKey: 'mcpPlatform',
  },
  {
    id: 'mcp-oauth-clients',
    labelKey: 'mcpOAuth',
    icon: KeyRound,
    href: '/admin/mcp/oauth',
    categoryKey: 'mcpPlatform',
  },
  {
    id: 'mcp-global-limits',
    labelKey: 'mcpLimits',
    icon: Gauge,
    href: '/admin/mcp/limits',
    categoryKey: 'mcpPlatform',
  },
] as const;

export function getAdminTabs(t: TFunction<'adminNav'>): SidebarTab[] {
  return adminTabDefs.map((def) => ({
    id: def.id,
    label: t(def.labelKey),
    icon: def.icon,
    href: def.href,
    labelType: 'categoryKey' in def && def.categoryKey
      ? [t(`categories.${def.categoryKey}`)]
      : undefined,
  }));
}
